
import React, { useEffect, useState } from "react";
import Accordion from "./common/Accordion";
import InputFieldControl from "./common/InputFieldControl";
import { storeLead } from "./actions/StoreLeadAction";
import toast from "react-hot-toast";
import { apiRequest } from "../../../../utils/utils";

const TrackingInfoForm = ({
  customerDetails,
  editPermissions,
  refreshCustomerDetails = () => {},
}) => {
  const [ConfirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const [sourcesOptions, setSourcesOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [countriesList, setCountriesList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    country_name: "",
    city: "",
    state: "",
    utm_adgroupname: "",
    utm_campaign: "",
    utm_medium: "",
    utm_term: "",
    gclid: "",
    source: "",
    signup_type: "",
  });

  useEffect(() => {
    if (customerDetails) {
      fetchFromData();
    }
  }, [customerDetails]);

  useEffect(() => {
    fetchCountries();
    fetchSources();
  }, []);

  const fetchSources = async () => {
    const responseData = await apiRequest(
      `${process.env.REACT_APP_CRM}/crm/attributes/source/list`
    );
    if (responseData && responseData.length > 0) {
      const redata = responseData.map((it) => ({ id: it.id, value: it.value }));
      setSourcesOptions(redata);
    }
  };

  const fetchFromData = () => {
    setFormData({
      country_name: customerDetails.country_name || "",
      city: customerDetails.city || "",
      state: customerDetails.state || "",
      utm_adgroupname: customerDetails.utm_adgroupname || "",
      utm_campaign: customerDetails.utm_campaign || "",
      utm_medium: customerDetails.utm_medium || "",
      utm_term: customerDetails.utm_term || "",
      gclid: customerDetails.gclid || "",
      source: customerDetails.source || "",
      signup_type: customerDetails.signup_type || "",
    });
  };

  const fetchCountries = async () => {
    try {
      const mauticURL =
        process.env.REACT_APP_CRM_ADMIN;

      const response = await fetch(`${mauticURL}/api/crm/countries`, {
        method: "GET",
      });
      const countries = await response.json();
      if (countries.data && countries.data.length > 0) {
        setCountriesList(
          countries.data.map((country) => {
            return {
              id: country.name,
              value: country.name,
            };
          })
        );
      } else {
        setCountriesList([]);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  const handleInputChange = (valueFor, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [valueFor]: value,
    }));
  };

  const onEditClick = () => {
    setIsEditing(true);
  };

  const handleContactInfoSave = async () => {
    setConfirmationModalOpen(false);
    setIsLoading(true);

    if (!handleValidation()) {
      return;
    }

    const formDataToSend = {
      ...formData,
      lead_source: customerDetails.lead_source,
      email: customerDetails.email,
    };

    const response = await storeLead(formDataToSend);

    if (response.success) {
      toast.success("Lead Updated successfully!");
      await refreshCustomerDetails();
    } else {
      toast.error(
        "An error occurred while processing your request. Please try again!"
      );
    }

    setIsEditing(false);
    setIsLoading(false);
  };

  const handleCancelEdit = () => {
    fetchFromData();
    setIsEditing(false);
  };

  const handleValidation = () => {
    setErrors({});

    const errors = {};
    let isValid = true;

    setErrors(errors);
    return isValid;
  };

  const ActionButton = () => {
    if (isLoading) {
      return (
        <button className="editprimary-btn editsecondry-btn" disabled>
          Loading...
        </button>
      );
    }

    return (
      <React.Fragment>
        <button
          className="editprimary-btn editsecondry-btn"
          onClick={(e) => {
            e.stopPropagation();
            if (isEditing) {
              // onSaveClick();
              handleContactInfoSave();
            } else {
              onEditClick();
            }
          }}
        >
          {!isEditing && (
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <g clip-path="url(#clip0_501_8376)">
                  <path
                    d="M8.5 1.5C8.63132 1.36868 8.78722 1.26451 8.9588 1.19344C9.13038 1.12236 9.31428 1.08578 9.5 1.08578C9.68572 1.08578 9.86962 1.12236 10.0412 1.19344C10.2128 1.26451 10.3687 1.36868 10.5 1.5C10.6313 1.63132 10.7355 1.78722 10.8066 1.9588C10.8776 2.13038 10.9142 2.31428 10.9142 2.5C10.9142 2.68572 10.8776 2.86961 10.8066 3.04119C10.7355 3.21277 10.6313 3.36868 10.5 3.5L3.75 10.25L1 11L1.75 8.25L8.5 1.5Z"
                    stroke="#006EFA"
                    stroke-width="1.33"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_501_8376">
                    <rect width="12" height="12" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
            </span>
          )}
          {isEditing ? "Save" : "Edit"}
        </button>
        {isEditing && (
          <button
            className="editprimary-btn editsecondry-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleCancelEdit();
            }}
          >
            {"Cancel"}
          </button>
        )}
      </React.Fragment>
    );
  };

  return (
    <Accordion
      header="Tracking Info"
      targetID="trackingInfoForm"
      actionButton={editPermissions && <ActionButton />}
      overrideOpenState={isEditing ? true : null}
    >
      <div className="form-customer-details">
        <div className="customer-info">
          <InputFieldControl
            fieldName="city"
            label="City"
            type={"text"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            error={errors.city}
          />
          <InputFieldControl
            fieldName="state"
            label="State"
            type={"text"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            error={errors.state}
          />
          <InputFieldControl
            fieldName="country_name"
            label="Country"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={countriesList}
            isLoading={isLoading}
            error={errors.country_name}
          />
          <InputFieldControl
            fieldName="utm_adgroupname"
            label="UTM Ad Group Name"
            type={"text"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            error={errors.utm_adgroupname}
          />
          <InputFieldControl
            fieldName="utm_campaign"
            label="UTM Campaign"
            type={"text"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            error={errors.utm_campaign}
          />
          <InputFieldControl
            fieldName="utm_medium"
            label="UTM Medium"
            type={"text"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            error={errors.utm_medium}
          />
          <InputFieldControl
            fieldName="utm_term"
            label="UTM Term"
            type={"text"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            error={errors.utm_term}
          />
          <InputFieldControl
            fieldName="gclid"
            label="GCLID"
            type={"text"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            error={errors.gclid}
          />
          <InputFieldControl
            fieldName="source"
            label="Source"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={sourcesOptions || []}
            isLoading={isLoading}
            error={errors.source}
          />
          <InputFieldControl
            fieldName="signup_type"
            label="Signup Type"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={[
              { value: "EMAIL", id: "EMAIL" },
              { value: "SSO (GOOGLE)", id: "SSO (GOOGLE)" },
              { value: "MANUAL", id: "MANUAL" },
              { value: "GOOGLE", id: "GOOGLE" }
            ]}
            isLoading={isLoading}
            error={errors.signup_type}
          />
        </div>
      </div>
    </Accordion>
  );
};

export default TrackingInfoForm;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/TrackingInfoForm.js